import { Carousel, Col, Row } from "antd";
import React, { useLayoutEffect } from "react";
import {
  GET_LOCAL_STORAGE,
  LOCAL_STORAGE_KEY,
} from "../../helpers/localStorage";
import { RE_DIRECT_TO } from "../../helpers/redirectHelper";
import { LOCAL_IMAGE } from "../../images/ImageConstant";
import "../login/login.scss";
import LoginForm from "./LoginForm";

function IndexOfLogin() {
  if (GET_LOCAL_STORAGE(LOCAL_STORAGE_KEY.cognitoIdentity)) {
    RE_DIRECT_TO("/role-selection");
  }
  // useEffect(() => {
  //   if (
  //     localStorage.getItem(
  //       "CognitoIdentityServiceProvider.1nodo54pao39u879c1672u5ls6.LastAuthUser"
  //     )
  //   ) {
  //     RE_DIRECT_TO("/role-selection");
  //   }
  // });
  useLayoutEffect(() => {
    document.body.style.backgroundColor = "#FFFFFF";
  });
  if (!GET_LOCAL_STORAGE(LOCAL_STORAGE_KEY.cognitoIdentity))
    return (
      <div>
        <div className="m-0 p-0 ">
          {/* <Button onClick={RE_DIRECT_DASHBOARD}>Re-dir</Button>
        <Button
          onClick={() =>
            SET_COOKIE(COOKIE_CONSTANTS.ROLE_SELECTION, {
              name: "c",
              JWT: "dsvdshj2312bnbcxz",
              id: "2",
              role: "user",
            })
          }
        >
          Login
        </Button>
        <Button onClick={REMOVE_ALL_COOKIE}>out</Button>
        <Button>see</Button>
        <Button onClick={GET_ALL_COOKIE}>see all</Button> */}
          <Row className="block md:flex">
            <Col lg={12} sm={24} className="my-auto bg-[#f2f7fb] h-[100vh]">
              <div className="my-9"></div>
              <div className="flex justify-center">
                <img
                  src={LOCAL_IMAGE.LOGO}
                  className="h-[33px] object-contain"
                />
              </div>
              <div className="my-9"></div>
              <Carousel autoplay>
                <div>
                  <img src={LOCAL_IMAGE.SLIDER_IMG1} className="m-auto" />
                </div>
                <div>
                  <img src={LOCAL_IMAGE.SLIDER_IMG1} className="m-auto" />
                </div>
                <div>
                  <img src={LOCAL_IMAGE.SLIDER_IMG1} className="m-auto" />
                </div>
              </Carousel>
            </Col>
            <Col lg={12} sm={24} className="  lg:my-auto sm:mx-auto">
              <div className="my-9"></div>
              {/* <CITest /> */}
              <LoginForm />
              <div className="my-9"></div>
            </Col>
          </Row>
        </div>
      </div>
    );
}

export default IndexOfLogin;
